@use 'styles/functions/rem' as *;
@use 'styles/mixins/fonts' as *;
@use 'styles/colors' as *;

.highlightTab {
    @include largerSemiboldFont;

    color: $highlightTabTextColor;
    cursor: pointer;
    display: flex;
    padding-bottom: rem(20px);
    padding-left: 0;
    text-align: center;
}

.tabActive {
    color: $highlightTabActiveColor;
}
